import React from "react"

import {useTheme} from "@irati/ui/src/global/useTheme"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {Label} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"

const Source: React.FC = () => {
  const theme = useTheme()
  return (
    <>
      <Icon icon={IconTypes.msTeams} marginRight />
      <Label color={theme.colors.fontColor}>
        <FormattedMessage id="recognition.source.msTeams" />
      </Label>
    </>
  )
}

export default Source
